import React from 'react';
import { Collapse } from 'antd';
import styles from './ScoreRulesAccordion.module.css';

const { Panel } = Collapse;

const panelHeader = (icon, title) => (
    <span className={styles.panelHeader}>
        <span className={styles.panelIcon}>{icon}</span>{title}
    </span>
);

const ScoreRules = () => {
    return (
        <div className={styles.container}>
            <h1>Zasady w turniejach BTT</h1>

            <Collapse accordion bordered={false} className={styles.accordion}>
                <Panel header={panelHeader('🎾', 'Uczestnicy turniejów BTT')} key="1">
                    <div className={styles.panelBody}>
                        <p>
                            W turniejach BTT mogą brać udział wyłącznie osoby grające w tenisa
                            ziemnego na poziomie amatorskim. Z udziału wykluczeni są zawodnicy
                            z przeszłością profesjonalną, wyraźnie przewyższający poziom
                            amatorski, których udział mógłby zakłócić wyrównaną rywalizację.
                        </p>
                    </div>
                </Panel>

                <Panel header={panelHeader('☀️', 'Mecze w turniejach jednodniowych')} key="2">
                    <div className={styles.panelBody}>
                        <p>
                            Mecze rozgrywane są w jednym z dwóch formatów, wybieranym dla
                            danego turnieju: <strong>best of 3</strong> lub
                            {' '}<strong>ProSet</strong>.
                        </p>
                        <p><strong>Best of 3</strong></p>
                        <ul>
                            <li>Mecz rozgrywany do dwóch wygranych setów.</li>
                            <li>
                                Pierwsze dwa sety gra się do 4 wygranych gemów; przy stanie 3:3
                                rozgrywany jest tiebreak do 7 punktów (z przewagą 2 punktów).
                            </li>
                            <li>
                                Przy remisie 1:1 w setach trzeci set zastępuje super tiebreak
                                do 10 punktów (również z przewagą 2 punktów).
                            </li>
                        </ul>
                        <p><strong>ProSet</strong></p>
                        <ul>
                            <li>
                                Jeden set rozgrywany do 9 gemów; przy stanie 8:8 rozgrywany
                                jest tiebreak do 7 punktów (z przewagą 2 punktów), zwycięski
                                wynik seta 9:8.
                            </li>
                        </ul>
                        <p>
                            W obu formatach gemy rozgrywane są z punktem decydującym przy
                            równowadze (no-ad scoring): w deblu stronę odbierającą wybierają
                            odbierający, a w singlu kierunek serwisu wybiera serwujący.
                        </p>
                    </div>
                </Panel>

                <Panel header={panelHeader('🏅', 'Mecze w lidze tenisowej')} key="3">
                    <div className={styles.panelBody}>
                        <ul>
                            <li>Mecze ligowe toczą się do dwóch wygranych setów.</li>
                            <li>
                                Każdy z pierwszych dwóch setów rozgrywany jest klasycznie do 6
                                gemów; przy stanie 6:6 rozgrywany jest tiebreak do 7 punktów
                                (z przewagą 2 punktów).
                            </li>
                            <li>Gemy rozgrywane są na przewagi (bez punktu decydującego).</li>
                            <li>
                                Przy remisie 1:1 w setach decydującym setem jest super tiebreak
                                do 10 punktów (z przewagą 2 punktów).
                            </li>
                            <li>
                                Zawodnicy, którzy ewidentnie unikają rozgrywania meczów, mogą
                                zostać ukarani walkowerem przez organizatora.
                            </li>
                        </ul>
                    </div>
                </Panel>

                <Panel header={panelHeader('🎯', 'Rozstawienia w turniejach')} key="4">
                    <div className={styles.panelBody}>
                        <p>
                            Gracze są rozstawiani w turniejach na podstawie punktów ELO oraz
                            wiedzy organizatora o aktualnym poziomie tenisowym danego zawodnika.
                            Ranking ELO nie jest jedynym wyznacznikiem rozstawienia —
                            organizator zastrzega sobie prawo do ostatecznej decyzji w tej
                            sprawie.
                        </p>
                    </div>
                </Panel>

                <Panel header={panelHeader('✍️', 'Wprowadzanie wyniku meczu')} key="5">
                    <div className={styles.panelBody}>
                        <ul>
                            <li>
                                Wynik meczu może wprowadzić do systemu każdy z uczestników
                                danego meczu.
                            </li>
                            <li>Obowiązek wpisania wyniku spoczywa na zwycięzcy meczu.</li>
                        </ul>
                    </div>
                </Panel>

                <Panel header={panelHeader('📊', 'Klasyfikacja „każdy z każdym"')} key="6">
                    <div className={styles.panelBody}>
                        <p>Miejsce w tabeli ustalane jest według następujących zasad:</p>
                        <ul>
                            <li>Liczba wygranych setów.</li>
                            <li>
                                Różnica gemów (gemy wygrane minus gemy przegrane).{' '}
                                <strong>Uwaga:</strong> punkty zdobyte w super tiebreaku
                                przeliczane są proporcjonalnie do liczby gemów w secie — np.
                                super tiebreak do 10 punktów przy setach granych do 4 gemów
                                liczony jest jako 4 gemy.
                            </li>
                            <li>
                                Wynik bezpośredniego meczu między zawodnikami o identycznym
                                bilansie.
                            </li>
                        </ul>
                    </div>
                </Panel>

                <Panel
                    header={panelHeader('✅', 'Potwierdzenie udziału w turnieju jednodniowym')}
                    key="7"
                >
                    <div className={styles.panelBody}>
                        <ul>
                            <li>
                                Udział potwierdza się automatycznie, jeśli uczestnik nie wypisze
                                się z listy zgłoszeniowej przed zamknięciem zapisów (sobota,
                                godz. 22:00).
                            </li>
                            <li>
                                W ciągu godziny po zamknięciu zapisów publikowana jest drabinka
                                turniejowa — od tego momentu wypisanie się nie jest już
                                możliwe.
                            </li>
                            <li>
                                Nieobecność uczestnika oznacza przegranie wszystkich jego
                                meczów walkowerem i utratę punktów ELO.
                            </li>
                        </ul>
                    </div>
                </Panel>

                <Panel header={panelHeader('⚖️', 'Rozstrzyganie sporów')} key="8">
                    <div className={styles.panelBody}>
                        <p>
                            Organizatorzy turniejów BTT zastrzegają sobie prawo do ostatecznego
                            rozstrzygania wszelkich kwestii spornych powstałych podczas trwania
                            rozgrywek.
                        </p>
                    </div>
                </Panel>
            </Collapse>
        </div>
    );
};

export default ScoreRules;
